<template>
    <section class="interview-title light yellow">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-coen.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light yellow">
                    <h3>Interview Coen&nbsp;van&nbsp;Hoof</h3>
                    <h2>Een leven lang ontwikkelen</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped></style>

<script>
    import InterviewCoen from '@/app/pages/sub/InterviewCoen';

    export default {
        name: 'RegioInterview2',
        meta: {
            title: 'RegioInterview2',
            color: '#FEBE06'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewCoen );
            }
        }
    };
</script>
